module.exports = __webpack_public_path__ + "img/acme-logo.64865e92.png";